export var FEDOPS_OVERRIDES_COOKIE = 'fedops.logger.defaultOverrides';
//# sourceMappingURL=const.js.map